import React from 'react';
import { getStyles } from './Icons';
export function ArrowBackIcon(props) {
    return (React.createElement("svg", { focusable: "false", style: getStyles(props), "aria-hidden": "true", viewBox: "0 0 24 24", role: "presentation" },
        React.createElement("path", { d: "M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z" })));
}
//# sourceMappingURL=ArrowBackIcon.js.map